// src/components/settings/shared/dialogs/RecycleBinConfirmDialog.tsx

import React from 'react';
import { Typography } from '@mui/material';
import {
  RestoreFromTrash as RestoreIcon,
  DeleteForever as DeleteForeverIcon,
} from '@mui/icons-material';
import DialogBase from '../../../common/modal/DialogBase';
import {
  ModalCancelButton,
  ModalSaveButton,
  ModalDeleteButton,
} from '../../../common/Buttons';

interface RecycleBinConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  variant: 'restore' | 'delete';
}

const RecycleBinConfirmDialog: React.FC<RecycleBinConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  variant,
}) => {
  const isDelete = variant === 'delete';

  return (
    <DialogBase
      draggable
      open={open}
      onClose={onClose}
      title={title}
      headerIcon={isDelete ? <DeleteForeverIcon /> : <RestoreIcon />}
      headerColor={isDelete ? 'secondary' : 'primary'}
      footer={
        <>
          <ModalCancelButton
            onClick={onClose}
            sx={{
              minWidth: { xs: 'auto', sm: '160px' },
              '& .MuiButton-startIcon': { display: { xs: 'none', sm: 'flex' } },
              ...(isDelete && {
                borderColor: 'secondary.main',
                color: 'secondary.main',
                '&:hover': {
                  letterSpacing: 'normal',
                  backgroundColor: 'secondary.light',
                },
              }),
            }}
          />
          {isDelete ? (
            <ModalDeleteButton
              onClick={onConfirm}
              text="Delete"
              sx={{
                minWidth: { xs: 'auto', sm: '160px' },
                '& .MuiButton-startIcon': {
                  display: { xs: 'none', sm: 'flex' },
                },
              }}
            />
          ) : (
            <ModalSaveButton
              onClick={onConfirm}
              text="Restore"
              sx={{
                minWidth: { xs: 'auto', sm: '160px' },
                '& .MuiButton-startIcon': {
                  display: { xs: 'none', sm: 'flex' },
                },
              }}
            />
          )}
        </>
      }
    >
      <Typography sx={{ fontSize: '1.8rem', mt: 1, textAlign: 'center' }}>
        {message}
      </Typography>
    </DialogBase>
  );
};

export default RecycleBinConfirmDialog;
